import styled from 'styled-components';

export const ScrollButton = styled.div`
  position: fixed;
  bottom: 15px;
  right: 15px;
  z-index: 2000;
`;
